import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setFastTitleFee } from '../../redux/modules/titlefees';
import Dropdown from '../../components/Dropdown';
import precise from '../../modules/precise';
import getFastTitleDropdownOptions from '../../modules/getFastTitleDropdownOptions';

class FastTitle extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const value = event.target.value;
    const label = this.getOptions()[event.target.selectedIndex][0];
    this.props.setFastTitleFee(precise(value), value, label);
  }

  getOptions() {
    return getFastTitleDropdownOptions(this.props);
  }

  render() {
    const { fastTitleFeeSelectedValue, fastTitleFee, fastTitleFeeSelectedValueLabel } = this.props;
    return (
      <div className="Row Title-feeRow">

        <input
          id="Tsub5"
          data-id="fastTitleFee"
          data-tooltip="Fast Title Fee"
          type="text"
          value={fastTitleFee}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          id="FastTitle"
          data-tooltip="Fast Title Fee - Additional Fee to Print Title"
          options={this.getOptions()}
          onChange={this.onValueSelect}
          selectedValue={fastTitleFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{fastTitleFeeSelectedValueLabel}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedVehicleValue: state.registration.selectedVehicleValue,
    selectedTitleVariables: state.titlefees.selectedTitleVariables,
    fastTitleFee: state.titlefees.fastTitleFee,
    fastTitleFeeSelectedValue: state.titlefees.fastTitleFeeSelectedValue,
    fastTitleFeeSelectedValueLabel: state.titlefees.fastTitleFeeSelectedValueLabel,
  };
};

export default connect(mapStateToProps, { setFastTitleFee })(FastTitle);



// WEBPACK FOOTER //
// ./src/containers/titlefees/FastTitle.js